/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> =
  | T
  | {
      [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never;
    };
import { gql } from 'apollo-angular';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export * from './graphql.schema-types';
export type UpdateZalamoInlineHelpMutationVariables = Exact<{
  text: string;
  id: string;
}>;

export type UpdateZalamoInlineHelpMutation = {
  updateZalamoInlineHelp: {
    text: string | null;
    zalamoInlineHelpId: string | null;
  } | null;
};

export type IsInlineHelpAdminQueryVariables = Exact<{ [key: string]: never }>;

export type IsInlineHelpAdminQuery = { isInlineHelpAdmin: boolean | null };

export const UpdateZalamoInlineHelpDocument = gql`
  mutation updateZalamoInlineHelp($text: String!, $id: ID!) {
    updateZalamoInlineHelp(text: $text, id: $id) {
      text
      zalamoInlineHelpId
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class UpdateZalamoInlineHelpGQL extends Apollo.Mutation<
  UpdateZalamoInlineHelpMutation,
  UpdateZalamoInlineHelpMutationVariables
> {
  document = UpdateZalamoInlineHelpDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const IsInlineHelpAdminDocument = gql`
  query isInlineHelpAdmin {
    isInlineHelpAdmin
  }
`;

@Injectable({
  providedIn: 'root',
})
export class IsInlineHelpAdminGQL extends Apollo.Query<
  IsInlineHelpAdminQuery,
  IsInlineHelpAdminQueryVariables
> {
  document = IsInlineHelpAdminDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
